import React, {useContext, useEffect, useState, useCallback, useRef} from "react"
import {FormattedMessage, injectIntl} from "react-intl";
import Column from "@amzn/meridian/column";
import {TableCell, TableRow} from "@amzn/meridian/table";
import MHEValidationTabHeader from "./mheValidationTabHeader";
import NewValidationModal from "./NewValidationModal";
import Loader from "../../loader/Loader";
import {MHEValidationContext} from "../../mhevalidation/context/MHEValidationContext";
import {
    chainWalk,
    getAssetRefreshInterval,
    getMHEValidationFormatDate,
    getObjectKeyForMHEValidationReport
} from "../../util/Util";
import Text from "@amzn/meridian/text";
import Button from "@amzn/meridian/button";
import Menu, {MenuItem} from "@amzn/meridian/menu";
import {
    MHE_VALIDATION_RESULT_COLORS,
    MHE_VALIDATION_STATUS_COLORS, MHE_VALIDATION_STATUS_TYPE
} from "../../util/Constants";
import Alert from "@amzn/meridian/alert";
import {GlobalStateContext} from "../../global/context/GlobalStateContext";
import {getLocalizedMessage} from "../../util/Localization";
import PaginatedTable from "../PaginatedTable";

const ValidationTabBody = (props) => {

    const {mheViewModel, mheDispatch} = useContext(MHEValidationContext);
    const {showCustomAlert} = useContext(GlobalStateContext);
    const [selectedMac, setSelectedMac] = useState("");
    const actionButtonRefs = useRef([]);
    const [openTriggerValidationModal, setOpenTriggerValidationModal] = useState(false);
    const [openActionsMenu, setOpenActionsMenu] = useState({});
    const {deviceList, dispatch, intl} = props;

    const onClickActionsButton = useCallback((index) => {
        let _open = {...openActionsMenu};
        _open[index] = true;
        setOpenActionsMenu(_open);
    }, []);

    const onCloseActions = useCallback((index) => {
        let _open = {...openActionsMenu};
        _open[index] = false;
        setOpenActionsMenu(_open)
    }, []);

    useEffect(() => {
        if (!openTriggerValidationModal && selectedMac) {
            getMHEValidationData()
            const interval = setInterval(() => {
                if (!document.hidden) {
                    getMHEValidationData();
                }
            }, getAssetRefreshInterval());
            return () => clearInterval(interval);
        }
    }, [selectedMac, openTriggerValidationModal]);

    const getMHEValidationData = () => {
        mheDispatch({type: 'LOAD_VIEW', data: { macAddress: selectedMac, dispatcher: mheDispatch}});
    }

    const getDeviceData = () => {
        setOpenTriggerValidationModal(false)
        dispatch({type: 'LOAD_VIEW', data: {dispatcher: dispatch}});
    }

    useEffect(() => {
        if (!openTriggerValidationModal) {
            getDeviceData()
            const interval = setInterval(() => {
                if (!document.hidden) {
                    getDeviceData();
                }
            }, getAssetRefreshInterval());
            return () => clearInterval(interval);
        }
    }, [openTriggerValidationModal]);


    useEffect(() => {
        actionButtonRefs.current = actionButtonRefs.current.slice(0, mheViewModel.mheValidationInformation
            .mheValidationInstanceList.length);
    }, [mheViewModel.mheValidationInformation.mheValidationInstanceList]);

    const getSelectedDevice = () => {
        return deviceList.find((device) => device.mac === selectedMac);
    }

    const downloadReport = (device, start, end) => {
        mheDispatch({type: "GET_PRESIGNED_URL", data: { objectKey: getObjectKeyForMHEValidationReport(device, start, end), dispatcher: mheDispatch, showCustomAlert: showCustomAlert}});
    }

    const getModalProps = () => {
        return {
            selectedDevice: getSelectedDevice(),
            state:openTriggerValidationModal,
            onStateChange:setOpenTriggerValidationModal,
            dispatch:mheDispatch
        }
    }

    const getHeaderProps = () => {

        return {
            selectedMac,
            setSelectedMac,
            deviceList,
            setOpenTriggerValidationModal,
            openTriggerValidationModal
        }
    }

    function renderMHEValidationTableHeader() {
        return (
            <TableRow>
                <TableCell width='15%'>{getLocalizedMessage({intl, stringId: "mhevalidation.starttime"})}</TableCell>
                <TableCell width='15%'>{getLocalizedMessage({intl, stringId: "mhevalidation.endtime"})}</TableCell>
                <TableCell width='12%'>{getLocalizedMessage({intl, stringId: "mhevalidation.status"})}</TableCell>
                <TableCell width='11%'>{getLocalizedMessage({intl, stringId: "mhevalidation.result"})}</TableCell>
                <TableCell width='12%'>{getLocalizedMessage({intl, stringId: "mhevalidation.requestedby"})}</TableCell>
                <TableCell width='30%'>{getLocalizedMessage({intl, stringId: "mhevalidation.remarks"})}</TableCell>
                <TableCell width='5%'>{getLocalizedMessage({intl, stringId: "mhevalidation.action"})}</TableCell>
            </TableRow>
        )
    }

    function isActionDisabled(status) {
        return status !== MHE_VALIDATION_STATUS_TYPE.COMPLETED && status !== MHE_VALIDATION_STATUS_TYPE.ERROR;
    }

    function renderMHEValidationTableRow(validation, index) {
        return ( <TableRow key={index}>
            <TableCell sortColumn="name" width='15%'>
                {getMHEValidationFormatDate(validation.startTime)}
            </TableCell>
            <TableCell sortColumn="name" width='15%'>
                {getMHEValidationFormatDate(validation.endTime)}
            </TableCell>
            <TableCell sortColumn="name" width='12%'>
                {<div style={{color: MHE_VALIDATION_STATUS_COLORS[validation.status]}}>
                    <b>{validation.status}</b>
                </div> }
            </TableCell>
            <TableCell sortColumn="name" width='11%'>
                <div style={{color: MHE_VALIDATION_RESULT_COLORS[chainWalk(() =>
                        validation.validationResultAttributes.result, "N/A")]}}>
                    <b>{chainWalk(() => validation.validationResultAttributes.result, "N/A")}</b>
                </div>
            </TableCell>
            <TableCell sortColumn="name" width='12%'>
                <div>{chainWalk(() => validation.validationAttributes.alias, "-")}</div>
            </TableCell>
            <TableCell sortColumn="name" width='30%'>
                <div>{chainWalk(() => validation.validationAttributes.remarks, "")}</div>
            </TableCell>
            <TableCell width='5%'>
                <Text type="b300">
                    <Button ref={el => actionButtonRefs.current[index] = el}
                            type="icon"
                            size="medium"
                            disabled={isActionDisabled(validation.status)}
                            onClick={() => onClickActionsButton(index)}
                            aria-controls="my-menu"
                            aria-haspopup="menu"
                            aria-expanded="false">
                        ...
                    </Button>
                    <Menu anchorNode={actionButtonRefs.current[index]}
                          open={openActionsMenu[index] ? openActionsMenu[index] : false}
                          position="left"
                          onClose={() => onCloseActions(index)}>
                        { validation.status === MHE_VALIDATION_STATUS_TYPE.COMPLETED &&
                            <MenuItem onClick={() => downloadReport(getSelectedDevice(),
                                validation.startTime, validation.endTime)}>
                                <FormattedMessage id="actions.download" defaultMessage="Download report"/>
                            </MenuItem>}
                    </Menu>
                </Text>
            </TableCell>
        </TableRow>)
    }


    return (<Column>
        <MHEValidationTabHeader {...getHeaderProps()}/>
        {selectedMac && ( mheViewModel.loadingValidationDetails ? <Loader/> :
            chainWalk(() => mheViewModel.mheValidationInformation.mheValidationInstanceList.length, 0) === 0 ?
                <Alert type="informational" size="small">
                    <FormattedMessage id="alert.mheValidation"
                                      defaultMessage="No validations present for this device."/>
                </Alert> : (<Column>
                    <PaginatedTable
                        data={mheViewModel.mheValidationInformation.mheValidationInstanceList}
                        renderRow={renderMHEValidationTableRow}
                        renderHeader={renderMHEValidationTableHeader}
                        numberOfRowsPerPage={10}
                    />
                    <div/>
                </Column>))}
        {openTriggerValidationModal && <NewValidationModal {...getModalProps()}/>}
    </Column>);
}

export default injectIntl(ValidationTabBody)



// WEBPACK FOOTER //
// ./src/components/commonui/mheValidation/ValidationTabBody.js